import { type PaymentMethodConstructor } from '@webapp/platform/banking/entities/PaymentMethod'
import { useCreateExternalPaymentMethodFormPresenter } from './useCreateExternalPaymentMethodFormPresenter'
import { ExternalPaymentMethodForm } from '../../views/ExternalPaymentMethodForm'

export interface ICreateExternalPaymentMethodFormPresenterProps {
  vendorId: number
  onCancel: () => void
  onSuccess?: (paymentMethod: PaymentMethodConstructor) => void
  shouldShowCancelButtonLabel?: boolean
}

export const CreateExternalPaymentMethodFormPresenter = ({
  vendorId,
  onCancel,
  onSuccess,
  shouldShowCancelButtonLabel,
}: ICreateExternalPaymentMethodFormPresenterProps) => {
  const {
    commands: { submitExternalPaymentMethodForm },
  } = useCreateExternalPaymentMethodFormPresenter({ vendorId, onSuccess })

  return (
    <ExternalPaymentMethodForm
      onSubmit={submitExternalPaymentMethodForm}
      onCancel={onCancel}
      shouldShowCancelButtonLabel={shouldShowCancelButtonLabel}
    />
  )
}
